






import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"
import {getLocationCaption} from "@/data/sources/appraisal"
import {bus} from "@/main";

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Custom(),
      widget: "ComplianceWorstPerformingElements",
      title: "Worst performing elements",
      cType: "scrollstackedbar2d",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      // fusionChartParams: {
      //   numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      // },
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: "Elements",
        showLabels: "1",
        numVisiblePlot: "6",
      },
    )
  }

  function chartDSTemplate() { // required if FC data not in {data: {}} format
    return {
      categories: [],
      dataset: [],
    }
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      async function dataplotClickCallback(label: string, value: string, data?: any) {
        if (label) {
          console.debug("label:", label, "value:", value, "data:", data)
          const locationId = props.config && props.config.params.locationId
          const element = label
          const riskLabelsMap = new Map<string, string[]>()
          riskLabelsMap.set("High", ["High", "Significant"])
          riskLabelsMap.set("Moderate", ["Moderate"])
          riskLabelsMap.set("Low", ["Low", "NA", ""])
          const riskLabels = riskLabelsMap.get(data.datasetName) || ["?"] // todo
          console.debug("locationId:", locationId, "element:", element, "value:", value)
          bus.$emit('chartPopup', {
            title: "Building " + await getLocationCaption(locationId) + " " + element + ": " + riskLabels + ", " + value,
            component: () => import('@/components/widgets/compliance/ComplianceWorstPerformingElementsDrillDown.vue'),
            componentArgs: {locationId: locationId.value, element, riskLabels},
          })
        }
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, chartDSTemplate, configChangeCallback}
    },
  })

  async function dataFetcher(params: any): Promise<{ locationid: bigint, risklabel: string, description: string, Value: number }[]> {
    // [{"Value":0,"locationid":123456,"risklabel":"High","description":"Building 1"},...]
    const locationId = parseInt(params.locationId.value)
    return executeQuery("idr", "compliance.worstPerformingElements",
      {locationId},
      convert,
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
    }
  }

  function convert(data: { locationid: bigint, risklabel: string, description: string, Value: number }[]): any {
    const categories: { label: string, additionalValue: bigint }[] = []
    const valuesMap = new Map<bigint, Map<string, number>>()
    for (const item of data) {
      if (!(valuesMap.has(item.locationid))) {
        categories.push({label: item.description, additionalValue: item.locationid})
        valuesMap.set(item.locationid, new Map<string, number>())
      }
      const values = valuesMap.get(item.locationid)
      if (typeof values != 'undefined') {
        values.set(item.risklabel, item.Value)
      }
    }
    const risks: { label: string, additionalValue: bigint, high: number, moderate: number, low: number }[] = categories.map(category => {
      const values = valuesMap.get(category.additionalValue)
      return {
        label: category.label,
        additionalValue: category.additionalValue,
        high: typeof values != "undefined" ? (values.get("High") || 0) + (values.get("Significant") || 0) : 0,
        moderate: typeof values != "undefined" ? (values.get("Moderate") || 0) : 0,
        low: typeof values != "undefined" ? (values.get("Low") || 0) + (values.get("") || 0) + (values.get("NA") || 0) : 0
      }
    }).sort((a, b) => {
      const high = b.high - a.high
      if (high !== 0) {
        return high
      }
      const moderate = b.moderate - a.moderate
      if (moderate !== 0) {
        return moderate
      }
      return b.low - a.low
    })
    const sortedCategories = risks.map(risk => {
      return {label: risk.label, additionalValue: risk.additionalValue}
    });
    const highDataset: { value: string }[] = risks.map(risk => {
      return {value: (risk.high !== 0 ? risk.high.toString() : "")}
    })
    const moderateDataset: { value: string }[] = risks.map(risk => {
      return {value: (risk.moderate !== 0 ? risk.moderate.toString() : "")}
    })
    const lowDataset: { value: string }[] = risks.map(risk => {
      return {value: (risk.low !== 0 ? risk.low.toString() : "")}
    })
    return {
      categories: [
        {
          category: sortedCategories,
        },
      ],
      dataset: [
        {
          seriesName: 'High',
          color: "#DC143C",
          data: highDataset,
        },
        {
          seriesName: 'Moderate',
          color: "#FFBF00",
          data: moderateDataset,
        },
        {
          seriesName: 'Low',
          color: "#6baa01",
          data: lowDataset,
        },
      ],
    }
  }
